import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { MEE6GuildProvider } from './contexts/MEE6GuildContext';

// Pages
import Home from './pages/Home/Home';
import Settings from './pages/Settings/Settings';
import Login from './pages/Login/Login';
import Callback from './pages/Login/Callback';
import Logout from './pages/Logout/Logout';
import CSAT from './pages/CSAT/CSAT';
import MEE6Dashboard from './pages/MEE6Dashboard/MEE6Dashboard';
import NotFound from './pages/404/404';
import MEE6GuildSettings from './pages/MEE6Dashboard/MEE6GuildSettings';
import TicketTracking from './pages/TicketTracking/TicketTracking';
import Performances from './pages/Performances/Performances';
import PersonalPerformances from './pages/PersonalPerformances/PersonalPerformances';
import PersonalCSATPage from './pages/PersonalCSAT/PersonalCSAT';
import RefundTracking from './pages/Refunds/Refunds';
import URLShortener from './pages/URLSHORTENER/URLShortener';

// Components
import Sidebar from './components/Sidebar/Sidebar';
import './App.scss';

const App = () => {
  return (
    <UserProvider>
      <MEE6GuildProvider>
        <Router>
          <div className="app-container">
            <Sidebar/>
            <div className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/mee6-dashboard" element={<MEE6Dashboard />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/login" element={<Login />} />
                <Route path="/auth/discord/callback" element={<Callback />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/csat" element={<CSAT />} />
                <Route path="/dashboard/:guildId" element={<MEE6GuildSettings />} />
                <Route path="/ticket-tracking" element={<TicketTracking />} />
                <Route path="/productivity" element={<Performances />} />
                <Route path="/personal-productivity" element={<PersonalPerformances />} />
                <Route path="/personal-csat" element={<PersonalCSATPage />} />
                <Route path="/refund-tracking" element={<RefundTracking />} />
                <Route path="/url-shortener" element={<URLShortener />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </div>
        </Router>
      </MEE6GuildProvider>
    </UserProvider>
  );
};

export default App;
